<div fxLayout="row">
  <div fxLayout="column" fxFlex>
    <mat-slide-toggle color="primary" [(ngModel)]="enabled" (change)="onEnabledChanged()">
      <div class="section-title">Referral link setting</div>
    </mat-slide-toggle>

    <form [formGroup]="form">
      @if (enabled) {
        <div fxLayout="column" class="link-info">
          <mat-form-field fxFlex style="margin-top: 10px;">
            <mat-label>Title</mat-label>
            <input specialIsAlphaNumeric #input matInput type="text" formControlName="referralTitle" placeholder="" autocomplete="off"
              maxlength="60">
            <mat-hint align="end">{{input.value?.length || 0}}/60</mat-hint>
          </mat-form-field>
          <mat-form-field fxFlex style="margin-top: 10px;">
            <mat-label>Short description</mat-label>
            <textarea formControlName="referralDescription" cdkTextareaAutosize cdkAutosizeMinRows="1"
              cdkAutosizeMaxRows="4" #textarea rows="1" matInput placeholder="" maxlength="300"
            autocomplete="off"></textarea>
            <mat-hint align="end">{{textarea.value?.length || 0}}/300</mat-hint>
          </mat-form-field>
          <mat-form-field fxFlex style="margin-top: 10px;">
            <mat-label>Referral Message</mat-label>
            <textarea formControlName="referralMessage" cdkTextareaAutosize cdkAutosizeMinRows="1"
              cdkAutosizeMaxRows="4" #textareaMessage rows="1" matInput placeholder="" maxlength="512"
            autocomplete="off"></textarea>
            <mat-hint align="end">{{textareaMessage.value?.length || 0}}/512</mat-hint>
          </mat-form-field>
        </div>
      }
    </form>
  </div>
  @if (enabled) {
    <div fxLayout="column">
      <p class="upload-image-title" [class.invalid]="!this.photoUrl">Thumbnail*</p>
      <div class="avatar-container thumb" (click)="fileInputAvatar.click()">
        <input class="hidden" #fileInputAvatar type="file" accept=".png, .jpg, .jpeg"
          (change)="onThumbImageSelected($event)">
        <div class="icon-container">
          <mat-icon color="primary">photo_camera</mat-icon>
        </div>
        <div class="avatar">
          <lib-photo [url]="photoUrl" [width]="'231.11px'" [height]="'130px'" [radius]="'10px'"></lib-photo>
        </div>
        @if (!photoUrl && !uploadPhotoKey) {
          <div class="image-info">Thumb 16:9</div>
        }
      </div>
      <p class="image-type-support">Format: png, jpg, jpeg <br> Size below 1MB</p>
    </div>
  }


</div>
